import { newDateFromUTC, newDateToUTC } from '@bc-library/common'

// DATA RECEIVED FOM API (FROM UTC)

// GENERAL CASE : ARRAY OR SINGLE OBJECT
export const afterReceiving = (data:any) => {
  if(data && Array.isArray(data)){
    data = data.map((object:any) => {
     return afterReceivingOne(object);
   })
  }
  else if(data.docs && data.count && Array.isArray(data.docs)){
    data.docs = data.docs.map((object:any) => {
      return afterReceivingOne(object);
    })
  }
  else if(typeof data == 'object'){
    data = afterReceivingOne(data);
  }
  return data;
};

// SINGLE OBJECT
export const afterReceivingOne = (object:any) => {
  if(typeof object == 'object'){
    return {
      ...object,
      _created: object._created && new Date(object._created),    
    }
  }
  return object;
}
